import { render, staticRenderFns } from "./BplSeasonalRating.vue?vue&type=template&id=224e6e92&scoped=true"
import script from "./BplSeasonalRating.vue?vue&type=script&lang=js"
export * from "./BplSeasonalRating.vue?vue&type=script&lang=js"
import style0 from "./BplSeasonalRating.vue?vue&type=style&index=0&id=224e6e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e6e92",
  null
  
)

export default component.exports